import { Legend } from "./Legend";
import { GrufReverbDecay } from "../parameterWidgets/GrufReverbDecay";
import { ParameterToggle } from "../parameterWidgets/ParameterToggle";
import { ADSRGraph } from "./ADSRGraph";
import { capitalize } from "$utils/string";
import { ParameterKnob } from "../parameterWidgets/ParameterKnob";
import { Enum2Columns } from "../parameterWidgets/Enum2Columns";
import { useSelector } from "react-redux";
import { ParameterHandler } from "../ParameterHandler";
import { DelayReturn } from "../channels/DelayReturn";
import { useMemo } from "react";
import { createReturnParameterSelector, setReturnParameter } from "../store";
import SeparatorLine from "jsx:$assets/widgets/separator_line.svg";
import { getWidgetData } from "../utils/parameters";


export const GrufModulADSR = ({className, instrument, soundNumber="", style, availableParameters=["env_attack", "env_decay", "env_sustain", "env_release"], colorizeLabel=false}) => {

    const knobs = availableParameters.map(parameter=> {
        const parameterName = parameter + soundNumber;
        return <ParameterKnob data-widget-id={`adsr${capitalize(parameter.replace("env_", ""))}`} key={parameter} mida="petit" parameterHandler={instrument.getParameterHandler(parameterName)} colorizeLabel={colorizeLabel} />
    })

    const attackParamName = `env_attack${soundNumber}`;
    const decayParamName = `env_decay${soundNumber}`;
    const sustainParamName = `env_sustain${soundNumber}`;
    const releaseParamName = `env_release${soundNumber}`;

    return (
        <div data-widget-id="adsr" className={`gruf-adsr-widget ${className}`}>
            <Legend text={getWidgetData("adsr").label.ca} style={{margin: "10px 0 0 10px"}}/>
            <ADSRGraph instrument={instrument} dynamicHighlight={false} adsrParameterNames={[attackParamName, decayParamName, sustainParamName, releaseParamName]}/>
            <div className="adsr-knobs">
                {knobs}
            </div>
        </div>
    )
}

export const GrufModulEQ = ({className, instrument}) => {
    return (
        <fieldset data-widget-id="equalizer" className={`gruf-modul gruf-modul-eq ${className}`}>
            <Legend text={getWidgetData("equalizer").label.ca} />
            <ParameterToggle data-widget-id="eqToggle" className="justify-self-end" parameterHandler={instrument.getParameterHandler("fx_EQ_isActive")} noLabel={true} />
            <div>
                <ParameterKnob data-widget-id="eqLow" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("fx_EQ_low")} />
                <ParameterKnob data-widget-id="eqMid" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("fx_EQ_mid")} />
                <ParameterKnob data-widget-id="eqHigh" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("fx_EQ_high")} />
            </div>
        </fieldset>
    )
    
}

export const GrufModulSends = ({ instrument, className, style }) => {
    return <fieldset data-widget-id="sends" className={`gruf-modul gruf-modul-sends ${className}`} style={style}>
        <Legend text={getWidgetData("sends").label.ca}/>
        <div className="sends-controls">
            <ParameterKnob data-widget-id="sendReverbA" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("send_reverbA")} label="Reverb A" />
            <ParameterKnob data-widget-id="sendReverbB" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("send_reverbB")} label="Reverb B" />
            <SeparatorLine className="row-span-full h-full" />
            <ParameterKnob data-widget-id="sendDelayA" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("send_delayA")} label="Delay A" />
            <ParameterKnob data-widget-id="sendDelayB" mida="gran" knobSize="50px" parameterHandler={instrument.getParameterHandler("send_delayB")} label="Delay B" />
        </div>
    </fieldset>
}

export const GrufModulDelay = ({name, className, returnName}) => {
    return(
        <fieldset className={`gruf-modul gruf-modul-delay ${className}`}>
            <Legend text={name} />
            <ParameterKnob mida="petit" parameterHandler={useMemo(() => new ParameterHandler(DelayReturn.parametersDescription.feedback, createReturnParameterSelector(returnName, "feedback"), value => setReturnParameter({returnName, parameter: "feedback", value})), [returnName])} />
            <label className="gruf-label-petit" style={{display: "contents"}}>
                Durada
                <Enum2Columns parameterHandler={useMemo(()=> new ParameterHandler(DelayReturn.parametersDescription.time, createReturnParameterSelector(returnName, "time"), value => setReturnParameter({returnName, parameter: "time", value})), [returnName])} />
            </label>
    </fieldset>
    )
}

export const GrufModulReverb = ({name, className, returnName, style={}}) => {
    return(
        <fieldset className={`gruf-modul gruf-modul-reverb ${className}`} style={style}>
            <Legend text={name} />
            <GrufReverbDecay returnName={returnName} />
        </fieldset>
    )
}
